import React from 'react';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';

interface IDateSelector {
  openDate: boolean;
  setOpenDate: any;
  handleDateChange: any;
  state: any;
  submit: any;
  setSubmit: any;
}

const DateSelector: React.FC<IDateSelector> = ({ state, handleDateChange, openDate, setOpenDate, submit, setSubmit }) => {
  return (
    <div className='date-selector-container'>
      <div className='date-selector-header'>
        <div className='date-selector-header-content'>
          <div className='date-selector-header-icon'>
            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
          <div className='date-selector-header-text-group'>
            <div className='date-selector-header-text-primary'>
              Filter by date
            </div>
            <div className='date-selector-header-text-secondary'>
              Select a single date or date range.
            </div>
          </div>
        </div>
        <div className='date-selector-header-close-btn' onClick={() => setOpenDate(false)}>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M18 6L6 18M6 6L18 18' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
      </div>
      <div className='date-selector-body'>
        <DateRangePicker
          value={state.date}
          onChange={(newValue: any) => handleDateChange(newValue)}
          localeText={{ start: 'Start Date', end: 'End Date' }}
          shouldDisableDate={(date: any) => {
            const today = new Date();
            // Disable all dates after today.
            return date > today;
          }}
          slotProps={{
            actionBar: {
              actions: [ 'clear' ],
            },
          }}
          sx={{
            'width': '100%',
            '& .MuiOutlinedInput-root': {
              '&:hover > fieldset': { borderColor: '#BDBEC1' },
              'color': '#BDBEC1',
              'borderRadius': '8px',
              'fontFamily': 'Inter',
              'fontSize': '14px',
              'fontStyle': 'normal',
              'fontWeight': '600',
            },
            '& .MuiButtonBase-root': {
              color: '#BDBEC1',
            },
            '& .MuiFormLabel-root': {
              color: '#BDBEC1',
            },
          }}
        />
      </div>
      <div className='date-selector-footer'>
        <div className='date-selector-divider'>
          <svg xmlns='http://www.w3.org/2000/svg' width='452' height='1' viewBox='0 0 452 1' fill='none'>
            <path fillRule='evenodd' clipRule='evenodd' d='M452 1H0V0H452V1Z' fill='#2E3036'/>
          </svg>
        </div>
        <div className='date-selector-actions'>
          <div className='date-selector-actions-content'>
            <div className='date-selector-cancel-btn' onClick={() => setOpenDate(false)}>
              <div className='date-selector-cancel-btn-text'>
                Cancel
              </div>
            </div>
            <div className='date-selector-apply-btn' onClick={() => {
              setSubmit({
                trigger: !submit.trigger,
                reason: 'apply'
              });
              setOpenDate(false);
            }}>
              <div className='date-selector-apply-btn-text'>
                Apply
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateSelector;
